<div
  id="tenant-table-container"
  class="matp-table-container tw-max-h-[calc(100vh_-_200px)]"
>
  <div class="matp-table-actions-area">
    <div class="matp-table-actions">
      <button
        mat-raised-button
        id="filter-clear-btn"
        class="tw-mr-2"
        (click)="clearFilters()"
      >
        <mat-icon>restart_alt</mat-icon>
        <span>クリア</span>
      </button>
      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="created.emit()"
      >
        <mat-icon>add</mat-icon>
        <span>新規登録</span>
      </button>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      id="tenant-table"
      class="matp-table"
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
      class="matp-table"
    >
      <!-- No -->
      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-min">
          <div class="matp-table-header-title">No</div>
        </th>
        <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
      </ng-container>
      <!-- テナントID -->
      <ng-container matColumnDef="tenantId">
        <th mat-header-cell *matHeaderCellDef class="!tw-w-24">
          <div mat-sort-header class="matp-table-header-title">テナントID</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="tenantId"
              type="text"
              [(ngModel)]="tenantIdKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="tenantid-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearTenantIdFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          <a
            href="javascript:void(0)"
            (click)="openTenantDetailDialog(element.tenantId)"
            >{{ element.tenantId }}</a
          >
        </td>
      </ng-container>
      <!-- テナント名 -->
      <ng-container matColumnDef="tenantName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">テナント名</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="tenantName"
              type="text"
              [(ngModel)]="tenantNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="tenantname-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearTenantNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.tenantName }}
        </td>
      </ng-container>
      <!-- 会社名 -->
      <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">会社名</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="companyName"
              type="text"
              [(ngModel)]="companyNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="companyname-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearCompanyNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.companyName }}</td>
      </ng-container>
      <!-- 説明 -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title">説明</div>
        </th>
        <td mat-cell *matCellDef="let element" class="tw-max-w-72 tw-truncate">
          {{ element.description }}
        </td>
      </ng-container>
      <!-- 操作 -->
      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-56 tw-max-w-56">
          <div class="matp-table-header-title">操作</div>
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-w-56">
          <div class="tw-flex">
            <div class="tw-mx-1">
              <button
                mat-stroked-button
                id="edit-btn"
                color="primary"
                (click)="updated.emit(element)"
              >
                <mat-icon>edit</mat-icon>
                <span>編集</span>
              </button>
            </div>
            <div class="tw-mx-1">
              <button
                mat-stroked-button
                id="delele-btn"
                color="primary"
                (click)="deleted.emit(element.tenantId)"
              >
                <mat-icon>delete</mat-icon>
                <span>削除</span>
              </button>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    id="tenant-table-paginator"
    [length]="dataSource.filteredData.length"
    [pageSize]="10"
    hidePageSize
    showFirstLastButtons
  ></mat-paginator>
</div>
